import React from 'react';

import { Icon, Label, Link } from '@opengov/component-library';

import { IAppSwitcherProducts, PRODUCT_ICONS } from '../types';

import { useAppSwitcherStore } from '../store/useAppSwitcherStore';

import styles from './AppSwitcherPopoverContent.module.scss';

interface IAppSwitcherPopoverContentProps {
  products: IAppSwitcherProducts;
  activeProduct: string;
}

export const AppSwitcherPopoverContent = (props: IAppSwitcherPopoverContentProps) => {
  const { activeProduct, products } = props;
  const productsWithoutAccess = useAppSwitcherStore((state) => state.getProductsWithoutAccess());
  const productsWithAccess = products?.entitled;

  return (
    <div className={styles.body}>
      {productsWithAccess && productsWithAccess.length > 0 ? (
        <Label className={styles.discoverLabel} variant="group" color="light">
          SWITCH APPLICATIONS
        </Label>
      ) : (
        ''
      )}
      {productsWithAccess &&
        productsWithAccess.map((product) => (
          <div
            key={product?.entitlementProductKey}
            className={`${styles.flex} ${
              activeProduct.toLowerCase() === product?.entitlementProductKey.toLowerCase() ? styles.active : ''
            }`}
          >
            {PRODUCT_ICONS[product?.entitlementProductKey.toLowerCase()] && (
              <Icon className={styles.prodIcon} icon={PRODUCT_ICONS[product?.entitlementProductKey.toLowerCase()]} />
            )}
            <Link.Standard
              openInNewTab={product.openInNewTab}
              className={styles.linkItem}
              text={product.displayName}
              href={product.url}
              title={product.description}
            />
          </div>
        ))}
      {productsWithoutAccess && productsWithoutAccess.length > 0 ? (
        <div className={styles.productsWithoutAccess}>
          <Label className={styles.discoverLabel} variant="group" color="light">
            DISCOVER OPENGOV SOLUTIONS
          </Label>
          {productsWithoutAccess.map((product) => (
            <React.Fragment key={product?.entitlementProductKey}>
              <div className={styles.flex}>
                {PRODUCT_ICONS[product?.entitlementProductKey.toLowerCase()] && (
                  <Icon
                    className={styles.prodIcon}
                    icon={PRODUCT_ICONS[product?.entitlementProductKey.toLowerCase()]}
                  />
                )}
                <div>
                  <Link.Standard
                    openInNewTab={true}
                    className={styles.linkItem}
                    text={product.displayName}
                    href={product.url}
                    title={product.description}
                  />
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      ) : (
        ''
      )}
    </div>
  );
};
